import axios from "axios";
import { API_URL } from "../../config/env";

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (process.env.NODE_ENV === "development") {
      console.debug("API Request:", {
        method: config.method?.toUpperCase(),
        url: config.url,
        headers: config.headers,
        data: config.data,
        params: config.params,
      });
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

const readStoredUser = () => {
  try {
    return JSON.parse(
      localStorage.getItem("user") || sessionStorage.getItem("user")
    );
  } catch {
    return null;
  }
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401: {
          const hadSession = Boolean(
            localStorage.getItem("access_token") ||
              sessionStorage.getItem("access_token")
          );
          const user = readStoredUser();
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          sessionStorage.removeItem("access_token");
          sessionStorage.removeItem("user");
          // Visiteur anonyme (p.ex. formulaire « Devenir vendeur ») : aucune
          // session à fermer, on laisse l'appelant afficher l'erreur.
          if (hadSession) {
            window.location.href =
              user?.role === "CLIENT" ? "/login" : "/vendor/login";
          }
          break;
        }
        case 403:
          console.error("Forbidden:", data);
          break;
        case 404:
          console.error("Not Found:", data);
          break;
        case 422:
          console.error("Validation Error:", data);
          break;
        case 500:
          console.error("Server Error:", data);
          break;
        default:
          console.error(`API Error ${status}:`, data);
      }
    } else if (error.request) {
      console.error("Network Error - No response received");
    } else {
      console.error("Error:", error.message);
    }

    return Promise.reject(error);
  }
);

export const apiClient = {
  get: (url, config = {}) => axiosInstance.get(url, config),
  post: (url, data = {}, config = {}) => axiosInstance.post(url, data, config),
  put: (url, data = {}, config = {}) => axiosInstance.put(url, data, config),
  patch: (url, data = {}, config = {}) =>
    axiosInstance.patch(url, data, config),
  delete: (url, config = {}) => axiosInstance.delete(url, config),
  upload: (url, formData, onProgress = null) =>
    axiosInstance.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    }),
};

export { axiosInstance };

